<template>
    <div class="row justify-content-between">
        <div class="col-md-6 mg-unbilled">
            <div class="card border-info">
                <div class="card-body text-info">
                    <h5 class="title-unbilled"><span class="fw-bold">UNBILLED LABOR HOURS:</span> {{unbilled.unbilled_labor_hours}}</h5>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card border-info">
                <div class="card-body text-info">
                    <h5 class="title-unbilled"><span class="fw-bold">UNBILLED PARTS/SUBS:</span> {{unbilled.unbilled_parts_subs}}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
    props: {
        unbilled: {
            type: Object,
            required: true
        }
    },

}
</script>